<div class="page">
  <div class="page__container">
    <h1 class="page__title h2 mb-5">{{ 'reseller_profiles_title' | translate }}</h1>
    <wsb-atlas-button class="my-3" [label]="'reseller_profiles_create'" (click)="createNewProfil()">{{
      'reseller_profiles_create' | translate
    }}</wsb-atlas-button>
    <div class="my-5">
      <ng-template #modalDelete let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalDeleteForm()"
          (dismiss)="d()"
          cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}"
          text="{{ 'reseller_profiles_delete_confirm' | translate }}"
        ></wsb-modal>
      </ng-template>
      <wsb-atlas-grid
        #grid
        *ngIf="tableColumnDefs"
        class="atlas-grid-simplest"
        class="mt-2"
        [loading]="tableLoading"
        [columnDefs]="tableColumnDefs"
        [rowData]="tableData"
        [options]="tableGridOptions"
        [@gridIsLoaded]="gridAnimationState"
        [components]="components"
      >
      </wsb-atlas-grid>
      <!--      [rowData]="tableData"-->
    </div>
  </div>
</div>
